import { render } from "./LibraryComponent.vue?vue&type=template&id=3748a538&scoped=true"
import script from "./LibraryComponent.vue?vue&type=script&lang=js"
export * from "./LibraryComponent.vue?vue&type=script&lang=js"

import "./LibraryComponent.vue?vue&type=style&index=0&id=3748a538&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3748a538"]])

export default __exports__